<template>
  <div>
    <div class="row">
      <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
        <div
          :class="{
            'has-error': validations.guia.atendimento.tipoAtendimento.$error,
          }"
          class="form-group"
        >
          <label for="tipoAtendimento"
            >46 - Tipo de atendimento <sup>(1)</sup></label
          >
          <select
            id="tipoAtendimento"
            v-model="guia.atendimento.tipoAtendimento"
            data-test-id="select-tipoatendimento"
            class="form-control"
          >
            <option disabled value=""> Selecione </option>
            <option
              v-for="tipo in tiposAtendimento"
              :key="tipo._id"
              :value="tipo.codigo"
            >
              {{ tipo.valor }}
            </option>
          </select>
          <span v-if="validations.guia.atendimento.tipoAtendimento.$dirty">
            <span
              v-if="!validations.guia.atendimento.tipoAtendimento.required"
              class="help-block"
            >
              Campo obrigatório.
            </span>
          </span>
        </div>
      </div>
      <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
        <div class="form-group">
          <label for="indicacaoAcidente">47 - Indicação de acidente</label>
          <select
            v-if="usuario.perfil !== 'Recepcionista'"
            id="indicacaoAcidente"
            v-model="guia.atendimento.indicacaoAcidente"
            data-test-id="select-indicacaoacidente"
            class="form-control"
          >
            <option disabled value=""> Selecione </option>
            <option
              v-for="indicacao in indicacoesAcidente"
              :key="indicacao._id"
              :value="indicacao.codigo"
            >
              {{ indicacao.valor }}
            </option>
          </select>
          <input
            v-if="!verificaAcao('faturamento_guia')"
            data-test-id="input-auto-3"
            type="text"
            readonly
            class="form-control"
          />
        </div>
      </div>
      <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
        <div class="form-group">
          <label for="tipoSaida">48 - Tipo de saída </label>
          <select
            id="tipoSaida"
            v-model="guia.atendimento.tipoSaida"
            data-test-id="select-tiposaida"
            class="form-control"
          >
            <option disabled value=""> Selecione </option>
            <option
              v-for="tipo in tiposSaida"
              :key="tipo._id"
              :value="tipo.codigo"
            >
              {{ tipo.valor }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'

import { dominioMixin } from '@/mixins/DominioMixin'
import ControleAcessoServico from '@/servicos/ControleAcessoServico'
import appStore from '@/stores'

const controleAcessoServico = new ControleAcessoServico()

export default {
  name: 'DadosAtendimento',
  mixins: [dominioMixin],
  props: {
    guia: {
      type: Object,
      required: true,
    },
    validations: {
      type: Object,
      required: true,
    },
    visaoSimplificada: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      tiposAtendimento: [],
      tiposSaida: [],
      indicacoesAcidente: [],
    }
  },
  computed: {
    usuario() {
      return appStore.usuario
    },
  },
  created() {
    this.recuperarValoresDominio('InidicacaoAcidente').then((res) => {
      this.indicacoesAcidente = res.valores
    })
    this.recuperarValoresDominio('TipoAtendimento').then((res) => {
      this.tiposAtendimento = res.valores
    })

    this.recuperarValoresDominio('TipoSaida').then((res) => {
      this.tiposSaida = res.valores
    })
  },
  methods: {
    verificaAcao(nome) {
      return controleAcessoServico.verificaAcao(nome)
    },
  },
}
</script>
